import Vue from 'vue'
import App from './App.vue'
import router from './router'

import './registerServiceWorker'

import './assets/app.css'
import ColescbaWeb from '@colescba/componentes-web'
Vue.use(ColescbaWeb, { baseURL: process.env.VUE_APP_API })

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import filters from './filters'
Object.keys(filters).forEach(filter => Vue.filter(filter, filters[filter]))

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

if (process.env.VUE_APP_ENABLE_TAILWIND_DEBUG_SCREENS === 'true') {
  document.body.classList.add('debug-screens')
}
